import { render, staticRenderFns } from "./b-popup-choose-gong-yi.vue?vue&type=template&id=963de858&scoped=true"
import script from "./b-popup-choose-gong-yi.vue?vue&type=script&lang=js"
export * from "./b-popup-choose-gong-yi.vue?vue&type=script&lang=js"
import style0 from "./b-popup-choose-gong-yi.vue?vue&type=style&index=0&id=963de858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963de858",
  null
  
)

export default component.exports